import React, { useState } from "react";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import classes from "../MasterDashboard.module.css";

const inr = (v) => {
  v = Math.round(v || 0);
  const abs = Math.abs(v);
  if (abs >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  return `₹${v.toLocaleString("en-IN")}`;
};

const SPOT_CARD_VISIBLE_N = 7;

const downloadRows = (rows, columns, fileName) => {
  if (!rows.length) {
    toast.error("Data is not available to download");
    return;
  }
  const exportRows = rows.map((row, index) => {
    const record = { "Sr No": index + 1 };
    columns.forEach(({ header, value }) => {
      record[header] = value(row);
    });
    return record;
  });
  const ws = XLSX.utils.json_to_sheet(exportRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, fileName);
};

/* ---------- headline KPI row ---------- */
const SpendHeroCard = ({ spend }) => (
  <div className={`${classes.card} ${classes.spotKpiHero}`}>
    <div className={classes.spotKpiLabel}>Approved spot spend</div>
    <div className={classes.spotKpiValue}>{inr(spend.total)}</div>
    {/* <div className={classes.spotSplitBar}>
      <i
        style={{ width: `${spend.contractedPct}%`, background: "var(--spotCon, #7d5ba6)" }}
        title={`Contracted lanes: ${inr(spend.contracted)} (${spend.contractedPct}%)`}
      >
        {spend.contractedPct > 12 ? `${spend.contractedPct}%` : ""}
      </i>
      <i
        style={{ width: `${spend.nonContractedPct}%`, background: "var(--spotNew, #5a6b8c)" }}
        title={`New lanes: ${inr(spend.nonContracted)} (${spend.nonContractedPct}%)`}
      >
        {spend.nonContractedPct > 12 ? `${spend.nonContractedPct}%` : ""}
      </i>
    </div> */}
    {/* <div className={classes.spotKpiRow}>
      <span>
        <span className={classes.spotSwatch} style={{ background: "var(--spotCon, #7d5ba6)" }} />
        Contracted lanes
      </span>
      <b>{inr(spend.contracted)}</b>
    </div>
    <div className={classes.spotKpiRow}>
      <span>
        <span className={classes.spotSwatch} style={{ background: "var(--spotNew, #5a6b8c)" }} />
        New lanes
      </span>
      <b>{inr(spend.nonContracted)}</b>
    </div> */}
  </div>
);

const NetSavingHeroCard = ({ netSaving }) => {
  const fmtPct = (pct) =>
    `(${pct > 0 ? "+" : pct < 0 ? "− " : ""}${Number(Math.abs(pct)).toFixed(1)}%)`;

  const newLanesSavings = netSaving?.newLanes?.amount ?? 0;
  const newLanesSavingsPct = netSaving?.newLanes?.pct ?? 0;

  const contractedLanesSavings = netSaving?.contractedLanes?.amount ?? 0;
  const contractedLanesSavingsPct = netSaving?.contractedLanes?.pct ?? 0;

  const totalSavings = netSaving?.amount ?? (newLanesSavings + contractedLanesSavings);

  const good = totalSavings >= 0;
  const color = good ? "var(--spotGood, #157f4a)" : "var(--spotBad, #c0392b)";

  return (
    <div className={`${classes.card} ${classes.spotKpiHero}`}>
      <div className={classes.spotKpiLabel}>Savings</div>

      <div className={classes.spotKpiValue} style={{ color }}>
        {totalSavings < 0 ? "− " : ""}
        {inr(Math.abs(totalSavings))}
      </div>

      {/* <div className={classes.spotKpiRow}>
        <span>New lanes</span>
        <b style={{ color: newLanesSavings >= 0 ? "var(--spotGood, #157f4a)" : "var(--spotBad, #c0392b)" }}>
          {newLanesSavings < 0 ? "− " : ""}
          {inr(Math.abs(newLanesSavings))} {fmtPct(newLanesSavingsPct)}
        </b>
      </div>

      <div className={classes.spotKpiRow}>
        <span>Contracted lanes</span>
        <b style={{ color: contractedLanesSavings >= 0 ? "var(--spotGood, #157f4a)" : "var(--spotBad, #c0392b)" }}>
          {contractedLanesSavings < 0 ? "− " : ""}
          {inr(Math.abs(contractedLanesSavings))} {fmtPct(contractedLanesSavingsPct)}
        </b>
      </div> */}
    </div>
  );
};

const SimpleKpiCard = ({ label, value, sublabel, lineLabel, lineValue }) => (
  <div className={`${classes.card} ${classes.spotKpiCard}`}>
    <div className={classes.spotKpiLabel}>{label}</div>
    <div className={classes.spotKpiValue}>{value}</div>
    {sublabel && <div className={classes.spotKpiSub}>{sublabel}</div>}
    {lineLabel && (
      <div className={classes.spotKpiLine}>
        <span>{lineLabel}</span>
        <b>{lineValue}</b>
      </div>
    )}
  </div>
);

const EnquiriesHeroCard = ({ enquiries }) => (
  <div className={`${classes.card} ${classes.spotKpiHero}`}>
    <div className={classes.spotKpiLabel}>Spot enquiries raised</div>
    <div className={classes.spotKpiValue}>{enquiries.raised}</div>
    {/* <div className={classes.spotSplitBar}>
      <i
        style={{ width: `${enquiries.contractedPerc}%`, background: "var(--spotCon, #7d5ba6)" }}
        title={`Contracted lanes: ${enquiries.contractedSpots} (${enquiries.contractedPerc}%)`}
      >
        {enquiries.contractedPerc > 12 ? `${enquiries.contractedPerc}%` : ""}
      </i>
      <i
        style={{ width: `${enquiries.nonContractedPerc}%`, background: "var(--spotNew, #5a6b8c)" }}
        title={`New lanes: ${enquiries.nonContractedSpots} (${enquiries.nonContractedPerc}%)`}
      >
        {enquiries.nonContractedPerc > 12 ? `${enquiries.nonContractedPerc}%` : ""}
      </i>
    </div> */}
    {/* <div className={classes.spotKpiRow}>
      <span>
        <span className={classes.spotSwatch} style={{ background: "var(--spotCon, #7d5ba6)" }} />
        Contracted lanes
      </span>
      <b>{enquiries.contractedSpots}</b>
    </div>
    <div className={classes.spotKpiRow}>
      <span>
        <span className={classes.spotSwatch} style={{ background: "var(--spotNew, #5a6b8c)" }} />
        New lanes
      </span>
      <b>{enquiries.nonContractedSpots}</b>
    </div> */}
  </div>
);

const SpotHeadlines = ({ metrics, cancelled }) => (
  <div className={classes.spotKpiGrid}>
    <SpendHeroCard spend={metrics.spend} />
    <EnquiriesHeroCard enquiries={metrics.enquiries} />
    <NetSavingHeroCard netSaving={metrics.netSaving} />
    <SimpleKpiCard
      label="Avg quotes per request"
      value={Number(metrics.quotes.avgQuotes || 0).toFixed(1)}
      sublabel={`${metrics.quotes.noQuoteCount} enquiries drew no quotes at all`}
      lineLabel="Quotes received"
      lineValue={Number(metrics.quotes.quotesReceived || 0).toLocaleString("en-IN")}
    />
    {cancelled != null && (
      <SimpleKpiCard
        label="Cancelled enquiries"
        value={cancelled}
        sublabel={
          metrics.enquiries.raised
            ? `${Math.round((cancelled / metrics.enquiries.raised) * 100)}% of spot raised`
            : undefined
        }
      />
    )}
  </div>
);

/* ---------- funnel ---------- */
const STAGE_COLORS = ["#1f6feb", "#17998c", "#6a9a1f", "#c2860b"];

const FunnelCard = ({ title, stages, unit }) => {
  const val = (stage) => (unit === "enq" ? stage.enquiries : stage.truckloads);
  const base = val(stages[0]) || 1;

  const rows = stages.map((stage) => {
    const v = val(stage);
    const pct = base ? Math.round((v / base) * 100) : 0;
    const barWidthPct = Math.min(100, Math.max(pct, 0));
    return { ...stage, v, pct, barWidthPct };
  });

  const exportFileName = `${title.toLowerCase().replace(/[^a-z0-9]+/g, "_")}.xlsx`;

  const handleDownload = () => {
    const exportRows = [...rows];
    if (unit === "enq" && stages.cancelled != null) {
      exportRows.push({ label: "Cancelled", v: stages.cancelled ?? 0 });
    }
    downloadRows(
      exportRows,
      [
        { header: "Stage", value: (r) => r.label },
        { header: unit === "enq" ? "Enquiries" : "Truckloads", value: (r) => r.v },
      ],
      exportFileName
    );
  };

  return (
    <div className={classes.card}>
      <div className={classes.cardHeaderRow}>
        <div className={classes.cardTitle}>{title}</div>
        <button
          type="button"
          className={classes.fullScreenButton}
          onClick={handleDownload}
          title="Download as Excel"
        >
          ⬇ Download
        </button>
      </div>
      <div className={classes.spotFunnel}>
        {rows.map((row, i) => (
          <React.Fragment key={row.label}>
            <div className={classes.spotFunnelLabel}>{row.label}</div>
            <div
              className={classes.spotFunnelBar}
              style={{
                width: `${Math.max(row.barWidthPct, 7)}%`,
                background: STAGE_COLORS[i],
                opacity: unit === "enq" ? 1 : 0.68,
              }}
            >
              <span>{row.v}</span>
              <span>{row.pct}%</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

/* ---------- business share (rank) + savings, by transporter ---------- */
const RankRows = ({ rows, max, color }) =>
  rows.map((r) => {
    const w = (r.spend / max) * 100;
    const inside = w > 16;
    return (
      <div className={classes.spotRankRow} key={r.transporterId || r.name}>
        <div className={classes.spotRankLabel} title={r.name}>
          {r.name}
        </div>
        <div className={classes.spotRankTrack}>
          <i style={{ width: `${w}%`, background: color }}>{inside ? `${r.sharePct}%` : ""}</i>
          {!inside && <span className={classes.spotRankOutside}>{r.sharePct}%</span>}
        </div>
        <div className={classes.spotRankValue}>{inr(r.spend)}</div>
      </div>
    );
  });

const RankTable = ({ rows }) => (
  <div className={classes.tableWrap}>
    <table className={`${classes.table} ${classes.spotNameTable}`}>
      <thead>
        <tr>
          <th style={{ textAlign: "center", width: "6%" }}>Sr No</th>
          <th style={{ textAlign: "center", width: "45%" }}>Name</th>
          <th style={{ textAlign: "center", width: "20%" }}>Share %</th>
          <th style={{ textAlign: "center", width: "29%" }}>Spend</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, index) => (
          <tr key={r.transporterId || r.name}>
            <td style={{ textAlign: "center" }}>{index + 1}</td>
            <td className={classes.spotNameCell}>{r.name}</td>
            <td style={{ textAlign: "center" }}>{r.sharePct}%</td>
            <td style={{ textAlign: "center", fontWeight: 700 }}>{inr(r.spend)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const RankCard = ({ title, rows, color = "#1f6feb", visibleCount = SPOT_CARD_VISIBLE_N }) => {
  const [expanded, setExpanded] = useState(false);
  const topRows = rows.slice(0, visibleCount);
  const max = rows.length ? Math.max(...rows.map((r) => r.spend)) : 1;
  const hasMore = rows.length > visibleCount;
  const exportFileName = `${title.toLowerCase().replace(/[^a-z0-9]+/g, "_")}.xlsx`;

  const handleDownload = () =>
    downloadRows(
      rows,
      [
        { header: "Name", value: (r) => r.name },
        { header: "Share %", value: (r) => r.sharePct },
        { header: "Spend", value: (r) => r.spend },
      ],
      exportFileName
    );

  return (
    <div className={classes.card}>
      <div className={classes.cardHeaderRow}>
        <div className={classes.cardTitle}>{title}</div>
        {rows.length > 0 && (
          <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
            <button
              type="button"
              className={classes.fullScreenButton}
              onClick={handleDownload}
              title="Download as Excel"
            >
              ⬇ Download
            </button>
            {hasMore && (
              <button
                type="button"
                className={`${classes.fullScreenButton} ${classes.fullScreenButtonLarge}`}
                onClick={() => setExpanded(true)}
                title="View all"
              >
                ⛶ View all ({rows.length})
              </button>
            )}
          </div>
        )}
      </div>
      <div>
        {rows.length ? (
          <RankRows rows={topRows} max={max} color={color} />
        ) : (
          <div className={classes.spotEmpty}>Nothing approved for this selection.</div>
        )}
      </div>
      {expanded && (
        <div className={classes.modalOverlay} onClick={() => setExpanded(false)}>
          <div className={`${classes.modalPanel} ${classes.modalPanelWide}`} onClick={(e) => e.stopPropagation()}>
            <div className={classes.modalHeaderRow}>
              <div className={classes.cardTitle}>{title}</div>
              <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                <button
                  type="button"
                  className={classes.fullScreenButton}
                  onClick={handleDownload}
                  title="Download as Excel"
                >
                  ⬇ Download
                </button>
                <button
                  type="button"
                  className={classes.modalCloseButton}
                  onClick={() => setExpanded(false)}
                >
                  ✕
                </button>
              </div>
            </div>
            <div className={classes.modalScrollArea} style={{ flex: 1, minHeight: 0 }}>
              <RankTable rows={rows} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const SavingsRows = ({ rows, max }) =>
  rows.map((r) => {
    const good = r.savings >= 0;
    const w = (Math.abs(r.savings) / max) * 100;
    return (
      <div className={classes.spotSavingsRow} key={r.transporterId || r.name}>
        <div className={classes.spotRankLabel}>{r.name}</div>
        <div className={classes.spotSavingsLeft}>
          {!good && (
            <div
              className={classes.spotSavingsBar}
              style={{ width: `${w}%`, background: "var(--spotBad, #c0392b)" }}
            />
          )}
        </div>
        <div className={classes.spotSavingsRight}>
          {good && (
            <div
              className={classes.spotSavingsBar}
              style={{ width: `${w}%`, background: "var(--spotGood, #157f4a)" }}
            />
          )}
        </div>
        <div
          className={classes.spotRankValue}
          style={{ color: good ? "var(--spotGood, #157f4a)" : "var(--spotBad, #c0392b)" }}
        >
          {good ? "+ " : "− "}
          {inr(Math.abs(r.savings))}
          <em className={classes.spotSavingsPct}>
            {r.savingsPct > 0 ? "+" : ""}
            {Number(r.savingsPct || 0).toFixed(1)}%
          </em>
        </div>
      </div>
    );
  });

const SavingsTable = ({ rows }) => (
  <div className={classes.tableWrap}>
    <table className={`${classes.table} ${classes.spotNameTable}`}>
      <thead>
        <tr>
          <th style={{ textAlign: "center", width: "6%" }}>Sr No</th>
          <th style={{ textAlign: "center", width: "40%" }}>Name</th>
          <th style={{ textAlign: "center", width: "27%" }}>Savings</th>
          <th style={{ textAlign: "center", width: "27%" }}>Savings %</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, index) => (
          <tr key={r.transporterId || r.name}>
            <td style={{ textAlign: "center" }}>{index + 1}</td>
            <td className={classes.spotNameCell}>{r.name}</td>
            <td
              style={{
                textAlign: "center",
                fontWeight: 700,
                color: r.savings >= 0 ? "var(--spotGood, #157f4a)" : "var(--spotBad, #c0392b)",
              }}
            >
              {r.savings >= 0 ? "+ " : "− "}
              {inr(Math.abs(r.savings))}
            </td>
            <td style={{ textAlign: "center" }}>
              {r.savingsPct > 0 ? "+" : ""}
              {Number(r.savingsPct || 0).toFixed(1)}%
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const SavingsCard = ({ title, rows }) => {
  const [expanded, setExpanded] = useState(false);
  const sorted = [...rows].sort((a, b) => b.savings - a.savings);
  const topRows = sorted.slice(0, SPOT_CARD_VISIBLE_N);
  const max = sorted.length ? Math.max(...sorted.map((r) => Math.abs(r.savings)), 1) : 1;
  const hasMore = sorted.length > SPOT_CARD_VISIBLE_N;
  const exportFileName = `${title.toLowerCase().replace(/[^a-z0-9]+/g, "_")}.xlsx`;

  const handleDownload = () =>
    downloadRows(
      sorted,
      [
        { header: "Name", value: (r) => r.name },
        { header: "Savings", value: (r) => r.savings },
        { header: "Savings %", value: (r) => r.savingsPct },
      ],
      exportFileName
    );

  return (
    <div className={classes.card}>
      <div className={classes.cardHeaderRow}>
        <div className={classes.cardTitle}>{title}</div>
        {sorted.length > 0 && (
          <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
            <button
              type="button"
              className={classes.fullScreenButton}
              onClick={handleDownload}
              title="Download as Excel"
            >
              ⬇ Download
            </button>
            {hasMore && (
              <button
                type="button"
                className={`${classes.fullScreenButton} ${classes.fullScreenButtonLarge}`}
                onClick={() => setExpanded(true)}
                title="View all"
              >
                ⛶ View all ({sorted.length})
              </button>
            )}
          </div>
        )}
      </div>
      <div>
        {sorted.length ? (
          <SavingsRows rows={topRows} max={max} />
        ) : (
          <div className={classes.spotEmpty}>Nothing approved for this selection.</div>
        )}
      </div>
      {expanded && (
        <div className={classes.modalOverlay} onClick={() => setExpanded(false)}>
          <div className={`${classes.modalPanel} ${classes.modalPanelWide}`} onClick={(e) => e.stopPropagation()}>
            <div className={classes.modalHeaderRow}>
              <div className={classes.cardTitle}>{title}</div>
              <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                <button
                  type="button"
                  className={classes.fullScreenButton}
                  onClick={handleDownload}
                  title="Download as Excel"
                >
                  ⬇ Download
                </button>
                <button
                  type="button"
                  className={classes.modalCloseButton}
                  onClick={() => setExpanded(false)}
                >
                  ✕
                </button>
              </div>
            </div>
            <div className={classes.modalScrollArea} style={{ flex: 1, minHeight: 0 }}>
              <SavingsTable rows={sorted} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const hasShare = (r) => r.spend !== 0 || r.sharePct !== 0;
const hasSavings = (r) => r.savings !== 0 || r.savingsPct !== 0;

const SpotOverviewTab = ({ metrics, funnelStages, topTransporters, byPlant }) => {
  if (!metrics || !metrics.enquiries.raised) {
    return (
      <div className={classes.placeholderCard}>
        <div className={classes.placeholderTitle}>No data available for this period</div>
        <div className={classes.placeholderText}>
          Please change the period or filters to see spot activity.
        </div>
      </div>
    );
  }

  const transporterShareRows = topTransporters.rows.filter(hasShare);
  const transporterSavingsRows = topTransporters.rows.filter(hasSavings);
  const plantShareRows = (byPlant?.rows || []).filter(hasShare);
  const plantSavingsRows = (byPlant?.rows || []).filter(hasSavings);

  return (
    <>
      <SpotHeadlines metrics={metrics} cancelled={funnelStages?.cancelled} />

      {funnelStages && (
        <div className={classes.spotTwoCol}>
          <FunnelCard title="Spot Funnel: By Enquiry" stages={funnelStages} unit="enq" />
          <FunnelCard title="Spot Funnel: By Truckloads" stages={funnelStages} unit="trk" />
        </div>
      )}

      <div className={classes.spotTwoCol}>
        <RankCard title="Business Share: By Transporter" rows={transporterShareRows} color="#1f6feb" visibleCount={10} />
        <SavingsCard title="Savings : By Transporter" rows={transporterSavingsRows} />
      </div>

      {byPlant && byPlant.rows.length > 0 && (
        <div className={classes.spotTwoCol}>
          <RankCard title="Business Share: By Plant" rows={plantShareRows} color="#c08a2e" visibleCount={10} />
          <SavingsCard title="Savings : By Plant" rows={plantSavingsRows} />
        </div>
      )}

      <div className={classes.spotFootnote}>
        <b>Note</b> Savings and business share are calculated on <b>approved spot rates</b>, not on
        actual placement. Approved value includes loads that lapsed before reaching an indent.
      </div>
    </>
  );
};

export default SpotOverviewTab;